export const QUERY_CUSTOM_REPORTS = `getProjectReports {
  project_reports(order_by: {created_at: desc}) {
    id
    name
    query_configs {
      features {
        feature
      }
      name
      description
      additional_config
      group_by_config
      linked_entity_config
    }
  }
}`;

export const QUERY_CUSTOM_REPORT_DETAILS_BY_ID = `getProjectReportById($id: uuid!) {
  project_reports_by_pk(id: $id) {
    id
    name
    query_configs {
      features {
        feature
      }
      name
      description
      group_by_config
      filters_config
      grid_config
      linked_entity_config
      sorts_config
      columns_config
      conditionals_formatting
      additional_config
    }
  }
}`;

export const QUERY_V_LARGE_MATERIAL = `vLargeMaterialQuery($where: v_large_materials_bool_exp) {
  v_large_materials(where: $where) {
    id
    sequence_id
    total_price
    workflow_status
    warranty
    actual_float
    delta
    due_date
    final_deadline_date
    linked_activities
    linked_submittals
    manufacturer
    material_size
    material_size_unit
    milestone_state
    next_action
    next_planned_deadline
    number
    part_number
    planned_float
    project_locations
    projected_last_milestone_date
    purchase_order
    quantity
    material_quantity_unit
    responsible_contractor_id
    responsible_contractor_name
    revision
    risk
    serial_number
    shipping_location
    spec_sections
    tag_name
    title
    unit_price
    gc_representative
    assignee_user
    offsets
    milestones
    description
    lead_time
    material_released_early
    last_manual_updated_at
    last_system_updated_at
  }
}`;
